import {React, useEffect, useRef, useState} from "react";
import { Box, Button, Typography, Container, Snackbar  ,Alert, CircularProgress} from "@mui/material";
import { useNavigate } from "react-router-dom";
import StepProgress from './StepProgress';
import { useAuth } from "../context/AuthContext";
import gb from '../assets/images/gbottom.png';



// ✅ Common Variables
const RAZORPAY_KEY = "rzp_live_lhpcAL8o4iO0Yz"; // Replace with your Razorpay Test Key ID
const APPS_SCRIPT_URL = "https://script.google.com/macros/s/AKfycbxp768SDsL5aN1b_qdZwjUckBX3QzcZ3vVLNClfGcZK3IhPAU1DUcaqIQutd48jV0QR0w/exec"; // Replace with your Google Apps Script URL
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;



const PaymentScreen = () => {
    const { user } = useAuth();
    const navigate = useNavigate();
    const paymentContainer = useRef(null);
    const [orderId, setOrderId] = useState(null);
    const [finalAmount, setFinalAmount] = useState(null);
    const [snackbarMessage, setSnackbarMessage] = useState("");
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const handleCloseSnackbar = () => {
        setOpenSnackbar(false);
      };



    const fetchOrder = async () => {
        setIsLoading(true);
        const mobile = localStorage.getItem("mobile");

        try {
            const amount = 2000; // Change dynamically if needed

            const params = new URLSearchParams({
                action: "createorder",
                mobile: mobile
        
            }).toString();

            const response = await fetch(`${API_BASE_URL}?${params}`, {
                method: "GET",
            });

            if (!response.ok) {
                throw new Error(`Server Error: ${response.status}`);
            }

            const orderData = await response.json();
            console.log("Order Data:", orderData);

            if (!orderData.orderId || !orderData.amount) {
                setIsLoading(false);
                throw new Error("Invalid order response");
                
            }

            setOrderId(orderData.orderId);
            setFinalAmount(parseInt(orderData.amount) * 100);
        } catch (error) {
            console.error("Error fetching order:", error);
            alert("Failed to create order. Please try again.");
        }
    };

    useEffect(() => {
        const mobile = localStorage.getItem("mobile");
    
        if (orderId && finalAmount && paymentContainer.current) {
            const options = {
                key: RAZORPAY_KEY,
                amount: finalAmount,
                currency: "INR",
                name: "TKS Trust",
                description: "UPI QR Payment",
                order_id: orderId,
                image: "/CWA_logo.png",
                theme: {
                    color: "#FFA500",
                    hide_topbar: false,
                },
                modal: {
                    backdropclose: false,
                    confirm_close: true,
                    animation: true,
                },
                handler: async function (response) {
                    console.log("Payment Successful:", response);

                    localStorage.setItem("payment_completed", "true");
                    
                    const mobile = localStorage.getItem("mobile");

                    const verifyParams = new URLSearchParams({
                        action: "verifypayment",
                        paymentid: response.razorpay_payment_id,
                        mobile:mobile
                    }).toString();

                    const verifyResponse = await fetch(`${API_BASE_URL}?${verifyParams}`, {
                        method: "GET",
                    });
                    // Convert response to JSON
                    const responseData = await verifyResponse.json();
                    setSnackbarMessage(responseData.message); // Show error message
                    setSnackbarOpen(true);
                    setIsLoading(false)
                    navigate("/receipt")
                },
                payment_capture: 1,
                method: {
                    upi: true,
                    netbanking: true,
                    card: true,
                },
                upi: {
                    flow: "collect",
                },
                prefill: {
                    contact: mobile,
                },
                container: paymentContainer.current,
            };
    
            try {
                const razorpay = new window.Razorpay(options);
                razorpay.on('payment.failed', function (response) {
                    console.error("Payment Failed:", response.error);
                    setSnackbarMessage(response.error.description || "Payment failed. Please try again.");
                    setSnackbarOpen(true);
                    setIsLoading(false);
                });
    
                razorpay.open();
            } catch (error) {
                console.error("Razorpay Error:", error);
                setSnackbarMessage("Failed to initiate payment. Please try again later.");
                setSnackbarOpen(true);
                setIsLoading(false);
            }
        }
    }, [orderId, finalAmount]);
    

   
    return (
        <Box sx={{ backgroundColor: "#f8f9e9", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", py: 6, position: "relative" }}> 
            {/* Step Indicator */}
            <StepProgress />

            {/* Payment Info */}
            <Typography variant="h6" className="text-[#2A289C] py-6 font-bold mb-3" sx={{ mb: 2 }}>
             Please proceed with a one-time payment of ₹2000.
            </Typography>

            
            {/* Proceed Payment Button */}
            {isLoading ? (
                <CircularProgress color="success" />
            ) : (
                <Button
                    variant="contained"
                    className="bg-green-500 text-white px-6 py-6 rounded-lg"
                    style={{ backgroundColor: "#28A745", color: "white" }}
                    onClick={fetchOrder}
                >
                    Proceed Payment
                </Button>
            )}
            <div ref={paymentContainer} id="razorpay-container" style={{ width: "100%", height: "0px" }}></div>

            <Typography color="#7A7841" sx={{ my: 4 }} >
            For transactions above or below ₹2000, we kindly request you to connect <br />with the 
             TKS Admin via +91 9841818740 or tsct041224@gmail.com
            </Typography>

            {/* Snackbar Alert */}
            <Snackbar open={openSnackbar} autoHideDuration={2000} onClose={handleCloseSnackbar} anchorOrigin={{ vertical: "top", horizontal: "right" }}  >
                <Alert onClose={handleCloseSnackbar} severity="success" sx={{ width: "100%", fontSize: "16px", fontWeight: "bold" }}>
                    Payemt Completed Successfully!
                </Alert>
            </Snackbar>     
            {/* Back Button */}
            <div className="flex space-x-4 mt-4">
            <Button
                variant="contained"
                className="bg-ash-500 hover:bg-ash-600 text-white px-6 py-2 rounded-lg"
                style={{ backgroundColor: "#6C757D", color: "white" }}
                onClick={() => {
                    navigate("/profile");
                    window.scrollTo(0, 0);
                }}
            >
                Back
            </Button>
            <Button
                variant="contained"
                className="bg-red-500 hover:bg-red-600 text-white px-6 py-2 rounded-lg"
                style={{ backgroundColor: "#E52029", color: "white" }}
                onClick={() => {
                    navigate("/");
                    window.scrollTo(0, 0); 
                }}
            >
                Cancel
            </Button>
            </div>
            

            {/* Footer Image - Positioned on the Bottom Left */}
            <Box
    sx={{
        position: "absolute",
        bottom: 0,
        left: 0,
        width: "400px", // default for desktop
        height: "150px", // default for desktop
        backgroundImage: `url(${gb})`,
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "left bottom",
        zIndex: 0,
        // Responsive styles for mobile
        '@media (max-width: 600px)': {
            width: '150px',   // adjust as needed for smaller screens
            height: '50px',  // adjust as needed for smaller screens
            backgroundSize: "cover", // or "contain" depending on how you want it to behave
        },
    }}
/>
        </Box>
        
    );
};

export default PaymentScreen;
